<template>
  <section class="max-w-lg py-8 mx-auto">
    <div class="mb-8">
      <h3
        class="mt-0"
        v-text="'Give this Report a Name:'"
      />
      <div class="w-full flex justify-start items-center">
        <div class="sm:w-1/2">
          <input
            id="report_name"
            v-model="form.name"
            :class="{ 'error': form.errors.has('name') }"
            style="margin-bottom: 0;"
            placeholder="Membership Report"
            type="text"
            name="report_name"
          >
          <div class="field__meta mt-2">
            <span
              v-if="form.errors.has('name')"
              class="field__meta__help"
              v-html="form.errors.get('name')"
            />
          </div>
        </div>
        <button
          type="button"
          class="btn btn--border btn--sm ml-4"
          @click="handleSave"
          v-text="'Save Report'"
        />
      </div>
    </div>
    <div class="mb-8">
      <h3 v-text="'Selected Columns:'" />
      <ul class="tags">
        <li
          v-for="column in selectedColumns"
          :key="column"
          class="tag-stack"
          v-text="column"
        />
      </ul>
    </div>
    <div class="mb-12">
      <h3 v-text="'Applied Filters:'" />
      <ActiveFilters
        v-if="activeFilters.length > 0"
        :active-filters="activeFilters"
        :show-actions="false"
      />
      <span
        v-else
        class="italic"
        v-text="'No filters have been applied.'"
      />
    </div>
    <div class="flex justify-center m-6">
      <button
        type="button"
        class="btn btn--link mr-4"
        @click="handleBack"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn mx-4"
        @click="runMembershipReport"
        v-text="'Run Report'"
      />
    </div>
    <SelectReportFormatModal
      :open="openSelectReportModal"
      @closeModal="openSelectReportModal = false"
      @downloadReport="downloadReport"
    />

    <AuthCodeModal
      :open="openAuthCodeModal"
      @closeModal="openAuthCodeModal = false"
      @authCodeVerified="authCodeVerified"
    />
  </section>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from 'vuex'
import { kebabCase } from 'lodash'
import Form from 'Base/Resources/assets/js/plugins/Form'
import ActiveFilters from 'Membership/Resources/assets/js/components/reports/ActiveFilters'
import SelectReportFormatModal from 'Membership/Resources/assets/js/components/_modals/SelectReportFormatModal'

export default {
  name: 'RunReport',
  components: {
    ActiveFilters,
    SelectReportFormatModal,
  },
  props: {
    selectedColumns: {
      type: Array,
      required: true,
    },
    activeFilters: {
      type: Array,
      required: true,
    },
    report: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      openSelectReportModal: false,
      openAuthCodeModal: false,
      form: new Form({
        name: this.report.length ? this.report.attributes.name : '',
        columns: [],
        filters: [],
      }),
    }
  },
  computed: {
    ...mapGetters({
      reportIsRunning: 'membershipIsMembershipReportRunning',
      availableColumns: 'membershipGetAvailableReportColumns',
    }),
    isUpdating() {
      return this.report.hasOwnProperty('uuid')
    },
  },
  watch: {
    isUpdating(element) {
      if (element) {
        this.form.name = this.report.attributes.name
      }
    },
  },
  methods: {
    ...mapActions({
      runReport: 'membershipRunMembershipReport',
    }),
    handleBack() {
      this.$emit('tabNavigation', {
        current: 'runReport',
        direction: 'back',
      })
    },
    authCodeVerified(){
      this.openAuthCodeModal = false
      this.openSelectReportModal = true
    },
    runMembershipReport() {
      if (!this.form.name) {
        this.displayError('A report name is required!')
      } else {
        this.openAuthCodeModal = true
      }
    },
    downloadReport(format) {
      this.runReport({
        url: 'memberships/reports/run',
        parameters: {
          'name': this.form.name,
          'columns': this.selectedColumns,
          'filters': this.activeFilters,
          'format': format,
        },
        reportName: kebabCase(this.form.name),
      }).then(() => {
        window.location = '/members/reports'
      })
    },
    handleSave() {
      this.form.columns = this.selectedColumns
      this.form.filters = this.activeFilters

      this.form.errors.clear()

      this.isUpdating ? this.updateMembershipReport(this.report.uuid) : this.saveMembershipReport()
    },
    updateMembershipReport(uuid) {
      this.$api.active().put(`memberships/reports/${uuid}`, this.form).then(() => {
        this.$store.commit('baseAddNotification', {
          title: 'Success!',
          text: 'Your report has been saved.',
          type: 'success',
        })
      }).catch((errors) => {
        this.form.setErrors(errors.response.data)
      })
    },
    saveMembershipReport() {
      this.$api.active().post('memberships/reports', this.form).then(() => {
        this.$store.commit('baseAddNotification', {
          title: 'Success!',
          text: 'Your report has been saved.',
          type: 'success',
        })
      }).catch((errors) => {
        this.form.setErrors(errors.response.data)
      })
    },
    displayError(string) {
      this.$store.commit('baseAddNotification', {
        title: 'Error!',
        text: string,
        type: 'error',
        timeout: false,
      })
    },
  },
}
</script>
